module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('popup', {
    attrs: {
      "heading": "New Ticket",
      "button-text": "Ticket",
      "button-style": "warning",
      "show-text": _vm.showText,
      "button-icon": "fa fa-exclamation-circle",
      "button-type": _vm.buttonType,
      "plain": _vm.plain,
      "round": _vm.round,
      "disable-button": _vm.enableSave
    },
    on: {
      "save": _vm.onSaveDialog,
      "close": _vm.onCloseDialog
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('el-form', {
    ref: "maintForm",
    attrs: {
      "model": _vm.formData,
      "label-width": "120px"
    }
  }, [_c('el-tabs', [_c('el-tab-pane', {
    attrs: {
      "label": "Issue"
    }
  }, [(!_vm.localSiteId) ? _c('select-site', {
    attrs: {
      "show-site": "",
      "required": ""
    },
    model: {
      value: (_vm.formData.site_id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "site_id", $$v)
      },
      expression: "formData.site_id"
    }
  }) : _vm._e(), _vm._v(" "), _c('select-ticket-category', {
    staticStyle: {
      "padding-top": "1em"
    },
    attrs: {
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.formData.category),
      callback: function($$v) {
        _vm.$set(_vm.formData, "category", $$v)
      },
      expression: "formData.category"
    }
  }), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('select-action-status', {
    attrs: {
      "disabled": !this.isTowerCo()
    },
    model: {
      value: (_vm.formData.status),
      callback: function($$v) {
        _vm.$set(_vm.formData, "status", $$v)
      },
      expression: "formData.status"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('select-priority', {
    model: {
      value: (_vm.formData.priority),
      callback: function($$v) {
        _vm.$set(_vm.formData, "priority", $$v)
      },
      expression: "formData.priority"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "issue",
      "label": "Details"
    }
  }, [_c('html-input', {
    model: {
      value: (_vm.formData.issue),
      callback: function($$v) {
        _vm.$set(_vm.formData, "issue", $$v)
      },
      expression: "formData.issue"
    }
  })], 1), _vm._v(" "), (this.isTowerCo()) ? _c('select-organisation', {
    attrs: {
      "label": "Reported by"
    },
    model: {
      value: (_vm.formData.organisation_id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "organisation_id", $$v)
      },
      expression: "formData.organisation_id"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isTowerCo()) ? _c('select-contractor', {
    model: {
      value: (_vm.formData.contractor_id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "contractor_id", $$v)
      },
      expression: "formData.contractor_id"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isTowerCo()) ? _c('select-workflow', {
    attrs: {
      "label": "Workflow",
      "disabled": true
    },
    model: {
      value: (_vm.formData.workflow_id),
      callback: function($$v) {
        _vm.$set(_vm.formData, "workflow_id", $$v)
      },
      expression: "formData.workflow_id"
    }
  }) : _vm._e()], 1), _vm._v(" "), (this.isTowerCo()) ? _c('el-tab-pane', {
    attrs: {
      "label": "Details"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "cause",
      "label": "Caused by"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Issue caused by"
    },
    model: {
      value: (_vm.formData.cause),
      callback: function($$v) {
        _vm.$set(_vm.formData, "cause", $$v)
      },
      expression: "formData.cause"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "fix",
      "label": "Fixed by"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 3,
      "placeholder": "Details of how the issue was fixed"
    },
    model: {
      value: (_vm.formData.fix),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fix", $$v)
      },
      expression: "formData.fix"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.isTowerCo()) ? _c('el-tab-pane', {
    attrs: {
      "label": "Scheduled"
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('switch-input', {
    attrs: {
      "label": "Repeated?",
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.formData.scheduledMaint),
      callback: function($$v) {
        _vm.$set(_vm.formData, "scheduledMaint", $$v)
      },
      expression: "formData.scheduledMaint"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('select-frequency', {
    model: {
      value: (_vm.formData.schedFrequency),
      callback: function($$v) {
        _vm.$set(_vm.formData, "schedFrequency", $$v)
      },
      expression: "formData.schedFrequency"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('date-input', {
    attrs: {
      "label": "Start",
      "options": _vm.dateOptions,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.formData.schedStart),
      callback: function($$v) {
        _vm.$set(_vm.formData, "schedStart", $$v)
      },
      expression: "formData.schedStart"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('date-input', {
    attrs: {
      "label": "End",
      "options": _vm.dateOptions,
      "disabled": _vm.disabled
    },
    model: {
      value: (_vm.formData.schedEnd),
      callback: function($$v) {
        _vm.$set(_vm.formData, "schedEnd", $$v)
      },
      expression: "formData.schedEnd"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e4bb7ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/TicketAction.vue
// module id = 1357
// module chunks = 0